import { render, staticRenderFns } from "./MarketBoxNew.vue?vue&type=template&id=40b1f7c2&"
import script from "./MarketBoxNew.vue?vue&type=script&lang=js&"
export * from "./MarketBoxNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports